<template>
  <div class="project">
    <div class="right-container">
      <div>
        <!-- <transition name="fadeOne">
          <div v-show="show" class="container-2"> -->
        <p class="One">Vala Chat</p>
        <p class="description">
          This was a Vue.js project. The task was to create the design for a
          tele-medicine company, with a focus on mental health. It is only
          front-end, no functionality has actually been implemented.
        </p>
        <!-- </div>
        </transition> -->
        <transition name="fadeTwo">
          <div class="container-2">
            <a href="https://vala-mental-health-chat.web.app/" class="Two"
              >click here to visit</a
            >
          </div>
        </transition>
      </div>
    </div>
    <div class="p-image"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-2 {
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}
.project {
  width: auto;
  height: auto;
  background: #4dba87;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 15px;
}
a {
  text-decoration: none;
  color: tomato;
}
button {
  color: #435466;
  font-size: 15px;
  font-weight: 600;
  background-color: #fff;
  margin: auto;
  width: 100px;
  height: 50px;
  border: #3b3561;
}
.right-container {
  display: grid;
  grid-template-rows: 1fr 0.1fr;
}
.p-image {
  background: url("../assets/vala-chat.png");
  height: 31vh;
  width: calc(35vh / 2);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
p {
  text-align: start;
  font-size: 50px;
  font-family: "Stalinist One", cursive;
  overflow: hidden;
  color: #000;
  margin: 1px;
}

.Two {
  font-size: 18px;
  margin: 10px 0 0 0;
}
.description {
  font-size: 1.5em;
  font-family: "Roboto", sans-serif;
}
.fadeOne-enter-active,
.fadeOne-leave-active {
  transition: all 0.5s ease-out;
}
.fadeOne-enter,
.fadeOne-leave-to {
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  transform: translate(0%, 100%);
}

.fadeTwo-enter-active,
.fadeTwo-leave-active {
  transition: all 0.5s ease-out;
}
.fadeTwo-enter,
.fadeTwo-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}
@media screen and (max-width: 600px) {
  .project {
    width: 100%;
    grid-template-columns: 1fr;
    place-items: center;
  }
  .p-image {
    width: 25vh;
    height: 44.4vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
